<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M15 2C15.5523 2 16 2.44772 16 3V6H17C18.6569 6 20 7.34315 20 9V12C20 15.3137 17.3137 18 14 18H13V21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21V18H10C6.68629 18 4 15.3137 4 12V9C4 7.34315 5.34315 6 7 6H8V3C8 2.44772 8.44772 2 9 2C9.55228 2 10 2.44772 10 3V6H14V3C14 2.44772 14.4477 2 15 2ZM17 8H7C6.44772 8 6 8.44772 6 9V12C6 14.2091 7.79086 16 10 16H14C16.2091 16 18 14.2091 18 12V9C18 8.44772 17.5523 8 17 8Z"
    fill="currentColor"
  />
</svg>
